import {branch, renderNothing} from 'recompose'

import compose from 'lodash/flowRight'
import * as React from 'react'

import withHook from '../hocs/withHook'

import {BuildLineLayoutContext, withBuildLineLayout} from './buildLineLayout'

// undefined = no provider, null = not measured yet
export const OneLineContext = React.createContext<boolean | null | undefined>(undefined)
export function useOneLine() {
  const buildLineLayout = React.useContext(BuildLineLayoutContext)
  const contextValue = React.useContext(OneLineContext)
  const oneLine = buildLineLayout.showPath === true ? false : contextValue

  if (process.env.NODE_ENV === 'test') {
    return oneLine ?? false
  }

  return oneLine
}
export type OneLineProps = {
  oneLine?: boolean | null
}
export const withOneLineContext = withHook(
  (): OneLineProps => ({
    oneLine: useOneLine(),
  }),
)
export const withOneLineProp = compose(
  withBuildLineLayout,
  withOneLineContext,
  branch((props: {oneLine: boolean | null}) => props.oneLine == null, renderNothing),
)
